import {UserList as BaseUserList} from '@/core'
import {doc} from './doc'
import styles from './style.module.styl'

export const UserList = doc(
  ({...props}) =>
    <BaseUserList
      getAvatarProps={({profile, nonprofit}) => ({
        square: profile.isNonprofitAccount,
        letter: (profile.isNonprofitAccount ? nonprofit.name[0] : profile.firstName?.[0]) || profile.email[0],
        src: nonprofit?.logo?.link
      })}
      getName={({profile, nonprofit}) => profile.isNonprofitAccount ? nonprofit?.name : (profile.firstName ? `${profile.firstName} ${profile.lastName}` : '')}
      {...props}
    />
)
